'use client';

import React, { FC } from 'react';
import { TypeNavItemFields } from '@/core/generated-types';
import { Link } from '@/navigation';
import { slugBuilder } from '@/core/contentfulConfig';
import classNames from 'classnames';

export const NavItem: FC<TypeNavItemFields> = ({
  badgeText,
  badgeColor,
  link,
  title,
}) => {
  const href = slugBuilder(link);
  const badgeColorClass =
    badgeColor?.fields?.color && `text-${badgeColor.fields.color}`;

  return (
    <Link
      href={href}
      data-testid="nav-item"
      className="flex items-center text-sm md:py-1 py-2"
    >
      <div className="text-charcoal-v2 flex-auto font-normal flex-none">
        {title}
      </div>
      {badgeText && (
        <div
          className={classNames('flex-none ml-2 font-bold', badgeColorClass)}
        >
          {badgeText}
        </div>
      )}
    </Link>
  );
};

export default React.memo(NavItem);
